import React, { Component } from 'react'
import { Browser } from '../../legacy'
import CloseButton from 'aria-viewer/tour/components/buttons/closeButton'
import Style from 'style-it'

const S = {
    container: {
        position: 'absolute',
        display: 'block',
        width: '100%',
        height: '100%',
        background: 'rgba(8,19,30,.85)',
        zIndex: 10000,
    },
    supportMessageBox: {
        position: 'absolute',
        color: 'black',
        display: 'block',
        fontSize: 16,
        textAlign: 'center',
        background: 'white',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%,-50%)',
        padding: 35,
        borderRadius: 5,
        width: 525,
        opacity: 0.9,
    },
    recommendedMessage: {
        textAlign: 'center',
        margin: '0 auto',
        display: 'inline-block',
        width: 180,
    },
    closeButton: {
        width: '1em',
        height: '1em',
        position: 'absolute',
        right: '0.5em',
        top: '0.5em',
        zIndex: 2005,
    },
}

class BrowserNotSupported extends Component {
    constructor(props) {
        super(props)
        this.state = { dismissed: false }
    }

    onCloseClicked = () => {
        this.setState({ dismissed: true })
    }

    shouldRender = () => {
        const data = Browser.getBrowserData()
        return (
            !this.state.dismissed &&
            ((data.browser === 'Explorer' && data.version < 11) ||
                (data.browser === 'Safari' && data.version < 9) ||
                (data.browser === 'Firefox' && data.version < 47))
        )
    }

    render() {
        return (
            this.shouldRender() && (
                <div style={S.container}>
                    <div style={S.supportMessageBox}>
                        <div>
                            <Style>
                                {` 
                        svg.icon_close_svg polygon {
                            fill: #D4D6D9;
                        }
                    `}
                            </Style>
                            <CloseButton style={S.closeButton} onClick={this.onCloseClicked} puresvg={true} />
                        </div>
                        <div>
                            <b> Your default browser or OS does not meet minimum requirements for VR experience. </b>
                        </div>
                        <br />
                        <div>Please update to the latest version of browser and OS for optimal viewing experience.</div>
                        <br />
                        <div style={S.recommendedMessage}>
                            Recommended Browsers:
                            <br />
                            <a href="https://www.google.com/chrome/browser/" target="_blank">
                                Chrome
                            </a>
                            <br />
                            <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" target="_blank">
                                Edge
                            </a>
                            <br />
                            <a href="https://support.apple.com/en-us/HT204416" target="_blank">
                                Safari
                            </a>
                            <br />
                            <a href="https://www.mozilla.org/firefox" target="_blank">
                                Firefox
                            </a>
                            <br />
                        </div>
                        <br />
                        <br />
                        <div>To update OS click on the link that corresponds to your format:</div>
                        <div style={S.recommendedMessage}>
                            <a href="https://www.apple.com/macos/how-to-upgrade/" target="_blank">
                                MAC
                            </a>
                            <br />
                            <a
                                href="https://support.microsoft.com/en-us/help/12435/windows-10-upgrade-faq"
                                target="_blank"
                            >
                                WINDOWS
                            </a>
                            <br />
                        </div>
                    </div>
                </div>
            )
        )
    }
}

export default BrowserNotSupported
